module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "bgltl"
  }, [_c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    attrs: {
      "alt": "image",
      "src": "images/img-008.1.jpg"
    }
  })]), _vm._v(" "), _c('h1', {
    staticClass: "fmtitle1",
    attrs: {
      "id": "bk"
    }
  }, [_c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_vm._v("ABOUT THIS BOOK")])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  }, [_c('p', {
    staticClass: "noindent"
  }, [_vm._v("This book is for new sewers, or those coming back to sewing who are finding that things have changed somewhat over the years! It’s for those of you who say, ‘I’ve had a sewing machine for years and never taken it out of the box’, or ‘I’d love to be able to sew but I don’t know where to start’.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I’ll take you on a guided tour of my sewing room, stopping off to explore the tools and equipment I use, while sharing with you many hints and tips that I’ve picked up over the years I’ve been sewing.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Although I enjoy dressmaking and quilting, my passion is for craft items and home décor, which is why my books are filled with pillow covers, tea cosies, accessories for my sewing room and lots of handbags! These types of projects are perfect for a beginner: quick sews that are purposeful and can be gifted. So, to keep this book from becoming too heavy to lift off the shelf, I’m concentrating on these types of projects! However, I’ve included just a few dressmaking and quilting tips that may help if that’s the journey you choose to take.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("My aim is to give the nervous sewer the confidence to give it a go, to take away any fear of sewing machines and to give you a little inspiration to get started.")]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    staticClass: " wht",
    attrs: {
      "alt": "image",
      "src": "images/img-005.1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    staticClass: " wht",
    attrs: {
      "alt": "image",
      "src": "images/img-006.1.jpg"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "img_container"
  }, [_c('img', {
    staticClass: " wht",
    attrs: {
      "alt": "image",
      "src": "images/img-007.1.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "page_5"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-72e2f11a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/05_AboutBook.vue
// module id = 72
// module chunks = 0